module.exports = __webpack_public_path__ + "icon-framework-ts.3_EWlN2H.svg";